import { orderBy, query } from "firebase/firestore";
import {
  FEED_API,
  PAYMENTS_API,
  REGIONS_API,
  ROLES_API,
  TEMPLATES_API,
  TICKETS_API,
} from "../../constants/api";
import { sortByDate } from "../../constants/filters";
import { ROLES, SORT } from "../../constants/strings";
import {
  FEED,
  PAYMENTS,
  REGIONS,
  TEMPLATES,
  TICKETS,
} from "../../constants/webapp";
import { usePayments } from "../payments/usePayments";
import { useRoles } from "../roles/useRoles";
import { useTemplates } from "../templates/useTemplates";
import { useTickets } from "../tickets/useTickets";
import { useFeed } from "../useFeed";
import { useRegion } from "../useRegion";

export const registerHooks = {
  [TICKETS]: useTickets,
  [PAYMENTS]: usePayments,
  [ROLES]: useRoles,
  [TEMPLATES]: useTemplates,
  [FEED]: useFeed,
  [REGIONS]: useRegion,
};

export const sourceApis = {};

export const registerQuery = {
  [TICKETS]: query(TICKETS_API, sortByDate()),
  [PAYMENTS]: query(PAYMENTS_API, sortByDate()),
  [ROLES]: query(ROLES_API, sortByDate()),
  [TEMPLATES]: query(TEMPLATES_API, sortByDate()),
  [FEED]: query(FEED_API, orderBy(SORT)),
  [REGIONS]: query(REGIONS_API, orderBy("region_name")),
};
